var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@3.6.0_webpack@3.12.0__handlebars@4.7.8_l_afaedb81a46d9d75a968e67803c82c7b/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74295820","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@3.6.0_webpack@3.12.0__handlebars@4.7.8_l_afaedb81a46d9d75a968e67803c82c7b/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 